/**
 * `bank` translations, for every locale -- the bank-list admin screen
 * (`pages/admin/Banks.tsx`).
 *
 * The top-level namespace is `bank`; a person's salary accounts are the
 * separate `hr.bank.*` in `areas/hr.ts`. `merge()` in `i18n/index.ts` is a plain
 * `Object.assign`, so a top-level collision would override SILENTLY.
 */
export const banks = {
  mn: {
    bank: {
      nav: 'Банкууд',
      title: 'Банкны жагсаалт',
      hint: 'Цалингийн болон төлбөрийн дансууд банкаа энэ жагсаалтаас сонгодог.',
      searchPlaceholder: 'Банк хайх',
      newBank: 'Шинэ банк',
      newTitle: 'Банк нэмэх',
      editTitle: 'Банк засах',
      nameEn: 'Нэр (англи)',
      nameMn: 'Нэр (монгол)',
      code: 'Банкны код',
      codeHint: 'Яг 4 оронтой тоо. Тодорхой биш бол хоосон орхино.',
      codeInvalid: 'Банкны код яг 4 оронтой, эсвэл хоосон байна.',
      status: 'Төлөв',
      active: 'Идэвхтэй',
      inactive: 'Идэвхгүй',
      inactiveNote: 'Идэвхтэй эсэхийг энэ хуудаснаас өөрчлөх боломжгүй.',
      loadFailed: 'Банкны жагсаалтыг ачаалж чадсангүй.',
      saveFailed: '«{{name}}» банкийг хадгалж чадсангүй.',
      createFailed: '«{{name}}» банкийг нэмж чадсангүй.',
      unchanged: 'Өөрчлөлт алга — хадгалах зүйл байхгүй.',
      nameEnMissing: 'Англи нэрийг оруулна уу.',
      nameMnMissing: 'Монгол нэрийг оруулна уу.',
      empty: 'Жагсаалтад банк байхгүй',
      noMatch: 'Хайлтад тохирох банк олдсонгүй',
      created: 'Банк нэмэгдлээ',
      saved: 'Банк хадгалагдлаа',
    },
  },
  en: {
    bank: {
      nav: 'Banks',
      title: 'Bank list',
      // Says what the list is FOR, because a bank name on its own does not:
      // renaming a row changes what every salary account and every invoice
      // payment line displays.
      hint: 'Salary and payment accounts choose their bank from this list.',
      searchPlaceholder: 'Search banks',
      newBank: 'New bank',
      newTitle: 'Add a bank',
      editTitle: 'Edit bank',
      nameEn: 'Name (English)',
      nameMn: 'Name (Mongolian)',
      code: 'Bank code',
      codeHint: 'Exactly 4 digits, or leave it blank if unverified.',
      codeInvalid: 'A bank code is exactly 4 digits, or leave it blank.',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      // An inactive bank IS shown (the list route returns it on purpose), and
      // this says why the state is read-only here rather than leaving a reader
      // hunting for a toggle that does not exist.
      inactiveNote: 'Whether a bank is active cannot be changed on this page.',
      loadFailed: 'Could not load the bank list.',
      saveFailed: 'Could not save bank “{{name}}”.',
      createFailed: 'Could not add bank “{{name}}”.',
      unchanged: 'Nothing has changed, so there is nothing to save.',
      nameEnMissing: 'Enter the English name.',
      nameMnMissing: 'Enter the Mongolian name.',
      empty: 'No banks on the list yet',
      noMatch: 'No bank matches that search',
      created: 'Bank added',
      saved: 'Bank saved',
    },
  },
  ru: {
    bank: {
      nav: 'Банки',
      title: 'Список банков',
      hint: 'Зарплатные и платёжные счета выбирают банк из этого списка.',
      searchPlaceholder: 'Поиск банка',
      newBank: 'Новый банк',
      newTitle: 'Добавить банк',
      editTitle: 'Изменить банк',
      nameEn: 'Название (английское)',
      nameMn: 'Название (монгольское)',
      code: 'Код банка',
      codeHint: 'Ровно 4 цифры. Оставьте пустым, если код не подтверждён.',
      codeInvalid: 'Код банка — ровно 4 цифры, либо оставьте поле пустым.',
      status: 'Статус',
      active: 'Активен',
      inactive: 'Неактивен',
      inactiveNote: 'Активность банка нельзя изменить на этой странице.',
      loadFailed: 'Не удалось загрузить список банков.',
      saveFailed: 'Не удалось сохранить банк «{{name}}».',
      createFailed: 'Не удалось добавить банк «{{name}}».',
      unchanged: 'Ничего не изменено — сохранять нечего.',
      nameEnMissing: 'Введите название на английском.',
      nameMnMissing: 'Введите название на монгольском.',
      empty: 'В списке пока нет банков',
      noMatch: 'Банк по этому запросу не найден',
      created: 'Банк добавлен',
      saved: 'Банк сохранён',
    },
  },
}
